import type { SaveService } from './save';

import { Environment } from '../../../environments/environment';

export function SaveRequest(this: SaveService, requestData: unknown): Promise<Response> {
  const _url = `${Environment.usersUrl}/saved-items`;
  const _authorization = `Bearer ${this.stateService.userToken()}`;
  const _options: RequestInit = {
    body: JSON.stringify(requestData),
    headers: {
      Authorization: _authorization,
      // eslint-disable-next-line @typescript-eslint/naming-convention -- This is the correct header name for content type.
      'Content-Type': 'application/json',
    },
    method: 'POST',
  };

  return fetch(_url, _options);
}
